import React from "react";
import { Box } from "@mui/material";
import HeroSection from "../components/home/HeroSection";
import ResponsiveShowcase from "../components/home/ResponsiveShowcase";
import VideoSection from "../components/home/VideoSection";
import StepsSection from "../components/home/StepsSection";
import imagen from "../images/wpchat.png";
const WHATSAPP_URL = "https://wa.me/message/HOYXZTTFNXNZH1";
const CALENDAR_URL = "https://calendar.app.google/tdG4zFKXJM2yPcX89";

export default function HomePage() {
    console.log("[HomePage] sideImage (imagen) =", imagen, "typeof:", typeof imagen);
  return (
    <Box component="main" sx={{ width: "100%", overflowX: "hidden" }}>
      <HeroSection
        heroImage="/hero.webp" // reemplazar por tu imagen
        onWhatsAppClick={() => (window.location.href = WHATSAPP_URL)}
        onPrimaryCtaClick={() => {
          const el = document.getElementById("read");
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }}
      />
      <div id="sabermas"></div>
      
      <VideoSection
        id="read"
        videoUrl="https://www.youtube.com/embed/kplXQUMm1wk"
        sideImage={imagen} // reemplazar por tu imagen
        onCalendarClick={() => (window.location.href = CALENDAR_URL)}
      />

      <ResponsiveShowcase />

      <StepsSection
        onCalendarClick={() => (window.location.href = CALENDAR_URL)}
        onWhatsAppClick={() => (window.location.href = WHATSAPP_URL)}
      />
    </Box>
  );
}
